import request from '@/utils/request'

export function codeAPI(api,postData){
  return request({
    url:'/'+api,
    method:'post',
    responseType:'blob',
    data:postData,
  })
}



// WEBPACK FOOTER //
// ./src/api/codeAPI.js